/**
 * 密码业务
 * @author Caesar Liu
 * @date 2019/3/29 11:34
 */

import request from '../utils/request'

/**
 * 设置密码
 */
export function setPwd (profile, pwd) {
  return request.post('/usr/pwd/reset', { ...profile, pwd })
}

/**
 * 发送找回密码短息
 */
export function sendFindPwdMc (mobile, icid, ic) {
  return request.post('/usr/pwd/find/mc', { mobile, icid, ic })
}

/**
 * 找回密码（手机号认证）
 */
export function findPwdByMobile (loginInfo, mobile, mcid, mc) {
  return request.post('/usr/pwd/find/mobile', { ...loginInfo, mobile, mcid, mc })
}

/**
 * 找回密码（微信认证）
 */
export function findPwdByWechat (data) {
  return request.post('/usr/pwd/find/wechat', data)
}
